import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/**
 * Процесс BPM
 * WARNING: не все поля примаплены
 **/
let PitBpmProcessInstance = class PitBpmProcessInstance {
    /**
     * Процесс BPM
     * WARNING: не все поля примаплены
     **/
    constructor() {
        this.id = null;
        this.code = null;
        this.name = null;
        /**
         * Id пользователя, запустившего инстанс БП.
         */
        this.initiatorId = null;
        this.initiatorLogin = null;
        this.initiatorName = null;
        /**
         * Идентификатор бизнесс-сущности, по которой запущен инстанс БП.
         */
        this.objectId = null;
        this.objectName = null;
        this.objectTypeId = null;
        this.startDateTime = null;
        this.finishDateTime = null;
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitBpmProcessInstance.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitBpmProcessInstance.prototype, "code", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitBpmProcessInstance.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitBpmProcessInstance.prototype, "initiatorId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitBpmProcessInstance.prototype, "initiatorLogin", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitBpmProcessInstance.prototype, "initiatorName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitBpmProcessInstance.prototype, "objectId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitBpmProcessInstance.prototype, "objectName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitBpmProcessInstance.prototype, "objectTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitBpmProcessInstance.prototype, "startDateTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitBpmProcessInstance.prototype, "finishDateTime", void 0);
PitBpmProcessInstance = tslib_1.__decorate([
    jsonObject
], PitBpmProcessInstance);
export { PitBpmProcessInstance };
